module.exports = function ($, _) {
  'use strict';

  $.fn.dataAttr = function (name, otherwise) {
    // Given name 'this', returns attr('data-this');
    // if traverseUp is given (defaults to true), continue traversing
    // upwards through DOM tree until a parent element is found with the
    // attr; closest wins in case of conflict.
    var nm = 'data-' + name,
      elem = this.closest('[' + nm + ']');

    if (elem.length === 0) {
      return otherwise;
    } else {
      var attr = elem.attr(nm);
      if (typeof attr == 'undefined') {
        return otherwise;
      } else {
        return attr;
      }
    }
  };

  $.fn.dataDict = function (name, otherwise) {
    // little helper to extract dict off multiple data-attributes with pattern data-dictname-*
    var nm = 'data-' + name + '-',
      result = {};
    $(this).each(function () {
      $.each(this.attributes, function () {
        if (this.specified && _.contains(this.name, nm)) {
          var parts = this.name.split('='),
            data_key = parts[0].substring(nm.length);
          result[data_key] = this.value;
        }
      });
    });
    if (result.length === 0) return otherwise;
    else return result;
  };
};
